export default "__VITE_ASSET__0c9ecfdc__"